import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('payment', ['filters']),

    stateAmountLow: {
      get () {
        return this.filters.amount_low
      },

      set (value) {
        this.setFilter({ filter: 'amount_low', value })
      }
    },

    stateAmountHigh: {
      get () {
        return this.filters.amount_high
      },

      set (value) {
        this.setFilter({ filter: 'amount_high', value })
      }
    },

    stateDateLow: {
      get () {
        return this.filters.date_low
      },

      set (value) {
        this.setFilter({ filter: 'date_low', value })
      }
    },

    stateDateHigh: {
      get () {
        return this.filters.date_high
      },

      set (value) {
        this.setFilter({ filter: 'date_high', value })
      }
    },

    stateLocations: {
      get () {
        return this.filters.locations
      },

      set (value) {
        this.setFilter({ filter: 'locations', value })
      }
    },

    stateOpportunities: {
      get () {
        return this.filters.opportunities
      },

      set (value) {
        this.setFilter({ filter: 'opportunities', value })
      }
    },

    stateStatus: {
      get () {
        return this.filters.status
      },

      set (value) {
        this.setFilter({ filter: 'status', value })
      }
    },

    stateRegions: {
      get () {
        return this.filters.regions
      },

      set (value) {
        this.setFilter({ filter: 'regions', value })
      }
    }
  },

  methods: {
    ...mapActions('payment', ['setFilter'])
  }
}
